<template>
  <div id="footer">
    <v-container grid-list-lg>
      <v-card flat class="transparent py-4">
        <v-layout row wrap>
          <v-flex md3 xs12>
            <v-layout fill-height align-end>
              <v-flex>
                <div class="my-4">
                  <span class="mb-3 mr-4">
                    <a class="white--text t__d--n" href="/">{{ trans('Home') }}</a>
                  </span>
                  <span class="mb-3 mx-4">
                    <a class="white--text t__d--n" href="/about-us">{{ trans('About') }}</a>
                  </span>
                  <span class="mb-3 mx-4">
                    <a class="white--text t__d--n" href="/contact-us">{{ trans('Contact Us') }}</a>
                  </span>
                </div>
                <div id="siteseal"></div>
                <!-- <v-text-field
                  label="Email Address"
                  dark
                  append-icon="alternate_email"
                  box
                  clearable
                  clear-icon="cancel"
                  hide-details
                ></v-text-field> -->
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex offset-md1 md4 xs12>
            <div class="mb-3">
              <a class="white--text t__d--n" href="/learning-strategy">{{ trans('Learning Strategy') }}</a>
            </div>
            <div class="mb-3">
              <a class="white--text t__d--n" href="/programmes/cybersecurity-law-and-cyber-terrorism">
                {{ trans('Cybersecurity Law & Cyber Terrorism') }}
              </a>
            </div>
            <div class="mb-3">
              <a class="white--text t__d--n" href="/programmes/cybersecurity-act-2018-compliance">
                {{ trans('Cybersecurity Act 2018 Compliance') }}
              </a>
            </div>
          </v-flex>
          <v-flex md4 xs12>
            <div class="mb-3">
              <a class="white--text t__d--n" href="/programmes/cybersecurity-governance-risk-and-compliance">
                {{ trans('Cybersecurity Governance, Risk & Compliance') }}
              </a>
            </div>
            <div class="mb-3">
              <a class="white--text t__d--n" href="/programmes/strategic-cybersecurity-risk-management">
                {{ trans('Strategic Cybersecurity Risk Management') }}
              </a>
            </div>
            <div class="mb-3">
              <a class="white--text t__d--n" href="/programmes/cybersecurity-performance-management">
                {{ trans('Cybersecurity Performance Management') }}
              </a>
            </div>
          </v-flex>
        </v-layout>
        <v-divider class="grey"></v-divider>
        <v-card dark flat class="transparent">
          <v-card-actions>
            <v-btn icon small>
              <v-icon small>mdi-linkedin</v-icon>
            </v-btn>
            <v-btn icon small>
              <v-icon small>mdi-facebook</v-icon>
            </v-btn>
            <v-btn icon small>
              <v-icon small>mdi-twitter</v-icon>
            </v-btn>
            <v-btn icon small>
              <v-icon small>mdi-instagram</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            &#169; 2018 Cyber Defence Academy.
          </v-card-actions>
        </v-card>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import store from '@/store'

export default {
  store,
  name: 'FooterComponent',

  props: {
    items: {
      type: [Object, Array],
      default: () => {
        return {}
      }
    }
  },

  data () {
    return {
      dataset: {},
      isEditing: false,
      footer: {

      }
    }
  },

  methods: {
    addSiteSeal () {
      let sslTag = document.createElement('script')

      sslTag.setAttribute('src', 'https://seal.godaddy.com/getSeal?sealID=kTiam8WJcVMHNPjeANHG4LnIvjjnV7LnyMTIWSPJ1UrTefLQ42rXNz6riKp5')
      sslTag.setAttribute('async', true)

      document.querySelector('#footer').appendChild(sslTag)
    },
  },

  mounted () {
    this.dataset = Object.assign({}, this.footer, this.items)

    this.addSiteSeal()
  },
}
</script>
